var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotificationBell = function SvgNotificationBell(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 21C7 22.6569 8.34315 24 10 24C11.6569 24 13 22.6569 13 21H7Z",
    fill: "#1967D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.927 1.2686C11.9746 1.18313 12 1.09305 12 1C12 0.447715 11.1046 0 10 0C8.89543 0 8 0.447715 8 1C8 1.09305 8.02542 1.18313 8.07297 1.2686C5.14405 2.1055 3 4.80236 3 8V16L2 17H1C0.447715 17 0 17.4477 0 18C0 18.5523 0.447715 19 1 19H3H17H19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17H18L17 16V8C17 4.80236 14.8559 2.1055 11.927 1.2686ZM15 17V8C15 5.23858 12.7614 3 10 3C7.23858 3 5 5.23858 5 8V17H15Z",
    fill: "#1967D2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationBell);
export default ForwardRef;